var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportUsers04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 28.2C18.7 28.2 15.4 25.1 14.1 20.7C13 20.7 12.1 19.4 12 17.9C11.9 16.4 12.6 15.1 13.5 14.8C13.8 8.79995 15.4 5.19995 21.5 5.19995C27.6 5.19995 29.2 8.79995 29.5 14.8C30.5 15 31.1 16.4 31 17.9C30.9 19.5 30 20.7 28.9 20.7C27.6 25.1 24.3 28.2 21.5 28.2Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 24.7C33.9 26.2 38.5 29.5 38.5 36.2C34 38.3 27.4 39.2 21.5 39.2C15.6 39.2 9 38.3 4.5 36.2C4.5 29.5 9.1 26.2 15.5 24.7",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 42.8C39.8735 42.8 43.5 39.1735 43.5 34.7C43.5 30.2265 39.8735 26.6 35.4 26.6C30.9265 26.6 27.3 30.2265 27.3 34.7C27.3 39.1735 30.9265 42.8 35.4 42.8Z",
    fill: "white",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 30.4V38.9",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 34.7H31.1",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportUsers04);
export default __webpack_public_path__ + "static/media/icons-2_export-USERS-04.ebdd9eda4e4857d588a981e05ae0ec87.svg";
export { ForwardRef as ReactComponent };